import { mapGetters } from 'vuex'

export default {
  methods: {
    getTranslatedContent(key, content=this.translations) {
      if (content[this.currentLanguage]) {
        return content[this.currentLanguage][key] || content.en[key]
      }
      return ''
    }
  },
  computed: {
    ...mapGetters('translations', [
      'translations',
      'currentLanguage'
    ]),
  }
}
